// Toon shader gradient + inverted-hull outline material factories.
// Per plan §5 art direction: cel banding + black outlines.

import {
  DataTexture,
  RedFormat,
  NearestFilter,
  MeshToonMaterial,
  ShaderMaterial,
  BackSide,
  Color,
} from 'three';

export function createCelGradient(): DataTexture {
  // 5-step gradient gives 5 cel bands. Per plan: hand-painted feel.
  const steps = new Uint8Array([60, 110, 160, 200, 245]);
  const tex = new DataTexture(steps, steps.length, 1, RedFormat);
  tex.minFilter = NearestFilter;
  tex.magFilter = NearestFilter;
  tex.generateMipmaps = false;
  tex.needsUpdate = true;
  return tex;
}

const cachedGradient = createCelGradient();

export function makeToon(color: number | string): MeshToonMaterial {
  return new MeshToonMaterial({
    color: new Color(color),
    gradientMap: cachedGradient,
  });
}

const outlineVertex = /* glsl */ `
  uniform float thickness;
  void main() {
    vec3 pos = position + normal * thickness;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
  }
`;

const outlineFragment = /* glsl */ `
  void main() {
    gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
  }
`;

export function makeOutline(thickness = 0.04): ShaderMaterial {
  return new ShaderMaterial({
    uniforms: { thickness: { value: thickness } },
    vertexShader: outlineVertex,
    fragmentShader: outlineFragment,
    side: BackSide,
  });
}
